/**
 * @fileoverview gRPC-Web generated client stub for csvexporter.private.invoices
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as invoices_pb from './invoices_pb';


export class InvoicesExporterServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorExportInvoices = new grpcWeb.MethodDescriptor(
    '/csvexporter.private.invoices.InvoicesExporterService/ExportInvoices',
    grpcWeb.MethodType.UNARY,
    invoices_pb.ExportInvoicesRequest,
    invoices_pb.ExportResponse,
    (request: invoices_pb.ExportInvoicesRequest) => {
      return request.serializeBinary();
    },
    invoices_pb.ExportResponse.deserializeBinary
  );

  exportInvoices(
    request: invoices_pb.ExportInvoicesRequest,
    metadata: grpcWeb.Metadata | null): Promise<invoices_pb.ExportResponse>;

  exportInvoices(
    request: invoices_pb.ExportInvoicesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: invoices_pb.ExportResponse) => void): grpcWeb.ClientReadableStream<invoices_pb.ExportResponse>;

  exportInvoices(
    request: invoices_pb.ExportInvoicesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: invoices_pb.ExportResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/csvexporter.private.invoices.InvoicesExporterService/ExportInvoices',
        request,
        metadata || {},
        this.methodDescriptorExportInvoices,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/csvexporter.private.invoices.InvoicesExporterService/ExportInvoices',
    request,
    metadata || {},
    this.methodDescriptorExportInvoices);
  }

}

